export const AppRoutes = {
  register: '/regisztracio',
  login: '/belepes',

  goToYettel() {
    window.location.href = 'https://yettel.hu';
  },
};
